import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import { Http500Error } from '@rover/utilities/HttpError';

import SeoLocationPage from '../types';

import CatSitting from './CatSitting';
import DogBoarding from './DogBoarding';
import DoggyDayCare from './DoggyDayCare';
import DogSitting from './DogSitting';
import DogWalking from './DogWalking';
import HouseSitting from './HouseSitting';
import PetBoarding from './PetBoarding';
import PetSitting from './PetSitting';

const DogTrainingErrorPage: SeoLocationPage = () => {
  throw new Http500Error();
};

const SEO_LOCATION_PAGE_FOR_TYPE: Record<ServiceTypeSlugEnum, SeoLocationPage> = {
  [ServiceTypeSlugEnum['cat-sitting']]: CatSitting,
  [ServiceTypeSlugEnum['dog-boarding']]: DogBoarding,
  [ServiceTypeSlugEnum['dog-walking']]: DogWalking,
  [ServiceTypeSlugEnum['doggy-day-care']]: DoggyDayCare,
  [ServiceTypeSlugEnum['house-sitting']]: HouseSitting,
  [ServiceTypeSlugEnum['pet-sitting']]: PetSitting,
  [ServiceTypeSlugEnum['pet-boarding']]: PetBoarding,
  [ServiceTypeSlugEnum['dog-sitting']]: DogSitting,
  [ServiceTypeSlugEnum['dog-training']]: DogTrainingErrorPage,
} as const;

export default SEO_LOCATION_PAGE_FOR_TYPE;
